import { render } from "./ColorBodyImage.vue?vue&type=template&id=e5ad5476&scoped=true"
import script from "./ColorBodyImage.vue?vue&type=script&lang=js"
export * from "./ColorBodyImage.vue?vue&type=script&lang=js"

import "./ColorBodyImage.vue?vue&type=style&index=0&id=e5ad5476&scoped=true&lang=css"

import exportComponent from "C:\\Projects\\sonic\\renault\\new_resources\\renault_configurator\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e5ad5476"]])

export default __exports__